import ContentCards from './ContentCards';

export default ContentCards;